import {Route} from '@angular/router';

export const routes: Route[] = [
  {
    path: 'auth',
    loadChildren: () => import('./view/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },
  {
    path: 'account',
    loadChildren: () => import('./view/account/account.routes').then(m => m.ACCOUNT_ROUTES)
  },
  {
    path: 'ops',
    loadChildren: () => import('./view/admin/admin.routes').then(m => m.ADMIN_ROUTES)
  },
  { // since we are changing account routes (app -> account), keep the old one for backward compatibility for a while
    path: 'app',
    loadChildren: () => import('./view/account/account.routes').then(m => m.ACCOUNT_ROUTES)
  },
  {
    path: '',
    loadChildren: () => import('./view/public/public.routes').then(m => m.PUBLIC_ROUTES)
  },
  { // since we are changing auth routes, keep the old one for backward compatibility for a while
    path: '',
    loadChildren: () => import('./view/auth/auth.routes').then(m => m.AUTH_ROUTES)
  }
  // { path: '**', redirectToRoute: ApplicationRoute.GuestDashboard},
];
